import React from "react";

import styled from "styled-components";
import { useSelector } from "react-redux";
import AlertComponent from "../../../_UI/Components/Alerts/AlertComponent";
import { CenteredMainDialog, Paragraph } from "../../../_UI/StyledComponents/StyledComponents";

const DeleteClientDialog = () => {
    const clientReducer = useSelector((state) => state.client);

    return (
        <DeleteDialog>
            <AlertComponent errorMessages={clientReducer.deleteClientErrorMessage} />
            <CenteredMainDialog>Soll {clientReducer.editClient.name} wirklich gelöscht werden? </CenteredMainDialog>

            <Paragraph>Bitte beachte, dass alle dazugehörigen Daten ebenfalls gelöscht werden.</Paragraph>
            <Paragraph>Dies sind z.B.:</Paragraph>
            <Paragraph>1. Integrationen (wie Stripe, Shopify etc.)</Paragraph>
            <Paragraph>2. Alle Buchungsstapel</Paragraph>
        </DeleteDialog>
    );
};

export default DeleteClientDialog;

const DeleteDialog = styled.div`
    display: grid;
    row-gap: var(--gap-m);
`;
